import React from 'react';
import { render } from 'react-dom';

import store from './redux/store';

import AppRoot from './modules/app/AppRoot';
import registerFocusHandlers from './focus';

import AppAPI from './api';

AppAPI.init().then(() => {
  registerFocusHandlers();
  render(<AppRoot store={store} />, document.getElementById('kustomer-root'));
});
